import { api } from '@/lib/api'

export interface ContactCallbackInput {
  firstName: string
  lastName: string
  email: string
  phone: string
  company?: string
  moment?: string
  teamSize?: string
  notes?: string
  source?: string
}

export interface ContactCallbackResponse {
  success: boolean
}

/**
 * POST /api/contact/callback/ — envoie une demande de rappel commercial.
 * Le backend envoie un email vers support@callizy.ca avec tous les champs structurés.
 */
export async function submitContactCallback(
  input: ContactCallbackInput,
): Promise<ContactCallbackResponse> {
  const { data } = await api.post<ContactCallbackResponse>('/api/contact/callback/', {
    firstName: input.firstName,
    lastName: input.lastName,
    email: input.email,
    phone: input.phone,
    company: input.company || '',
    moment: input.moment || '',
    teamSize: input.teamSize || '',
    notes: input.notes || '',
    source: input.source || 'app_subscribe',
  })
  return data
}
